import PropTypes from "prop-types";
import { Checkbox } from "semantic-ui-react";
import cn from "classnames";

import CroppedThumbnail from "../../croppedThumbnail/CroppedThumbnail";
import RestrictedByTooltip from "../../restrictedByTooltip/RestrictedByTooltip";

import "./cardThumbnail.scss";

function CardThumbnail(props) {
  const {
    thumbnailUrl,
    handleImageClick,
    selected,
    aspectRatio,
    children,
    disabled,
    hasEditPermission,
    isRadioButton,
    draggable,
    isHidden,
    label,
    labelColor,
    labelTooltipContent,
    selectable = true,
  } = props;

  const renderClickInput = () => {
    if (isRadioButton) {
      return renderRadioButton();
    } else {
      return renderCheckbox();
    }
  };

  const renderCheckbox = () => {
    return (
      <RestrictedByTooltip hasPermission={hasEditPermission ?? true} className="selection-checkbox-tooltip">
        <Checkbox disabled={disabled} className="selection-checkbox selection-field" checked={selected} />
      </RestrictedByTooltip>
    );
  };

  const renderRadioButton = () => {
    return (
      <RestrictedByTooltip hasPermission={hasEditPermission ?? true} className="selection-checkbox-tooltip">
        <Checkbox disabled={disabled} className="radio checkbox selection-field" checked={selected} type="radio" />
      </RestrictedByTooltip>
    );
  };

  return (
    <CroppedThumbnail
      thumbnailUrl={thumbnailUrl}
      aspectRatio={aspectRatio}
      onClick={handleImageClick}
      draggable={draggable}
      className={cn("card-thumbnail", { disabled })}
      placeholderContent={props.placeholderContent}
      isHidden={isHidden}
      label={label}
      labelColor={labelColor}
      labelTooltipContent={labelTooltipContent}
    >
      {selected !== undefined && selectable ? renderClickInput() : null}
      <div className="thumbnail-content">{children}</div>
    </CroppedThumbnail>
  );
}

CardThumbnail.propTypes = {
  thumbnailUrl: PropTypes.string,
  handleImageClick: PropTypes.func,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  aspectRatio: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
  hasEditPermission: PropTypes.bool,
  isRadioButton: PropTypes.bool,
  draggable: PropTypes.bool,
  placeholderContent: PropTypes.node,
  selectable: PropTypes.bool,
  isHidden: PropTypes.bool,
  label: PropTypes.string,
  labelColor: PropTypes.string,
  labelTooltipContent: PropTypes.string,
};

export default CardThumbnail;
